<template>
  <div id="loanInfo">
    <div>
      <p>Сумма займа</p>
      <p class="dealNumbers">{{demandState.Amount | moneyFormat}} ₽</p>
    </div>
    <div>
      <p>Срок займа</p>
      <p class="dealNumbers">{{demandState.period}} {{demandState.period | getWeekDeclension }}</p>
    </div>
    <div>
      <p>Еженедельный платеж</p>
      <p class="dealNumbers">{{demandState.FixedPay | moneyFormat}} ₽</p>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instProductInfo",
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
    })
  }
}
</script>

<style scoped>
#loanInfo{font-weight: 500}
#loanInfo div{padding: var(--font-size-16) 0;border-bottom: 1px solid var(--color-gray-type2);
  display: flex;align-items: center;justify-content: space-between}
.dealNumbers{color:var(--color-green)}
</style>